import { render } from "./details-my-team.vue?vue&type=template&id=19cee302"
import script from "./details-my-team.vue?vue&type=script&lang=js"
export * from "./details-my-team.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__